import { Box, Grid } from "@mui/material"
import MenuTab from "../../../component/tabs/MenuTab"
import TerreniForm from "./TerreniForm"
import { useSelector } from "react-redux";
// import StabilimentoForm from "./StabilimentoForm/StabilimentoForm"
// import SubImposteForm from "../Imposte/SubImposteForm"

const SubStrucutureTerreni = ({ Component }) => {
    const singleData = useSelector((state) => state.terreni.singleTerreni);
    
    return (
        <>
            <div className="pageTemplate">

                <Grid container spacing={3}>
                    <Grid size={{lg:3, md:4, xs:12}}>
                        <TerreniForm singleData={singleData} />
                    </Grid>
                    <Grid  size={{lg:9, md:8, xs:12}}>
                        <Box className="TemplateForm__right">
                            <MenuTab subTerreni={true} />
                        </Box>
                        {Component && <Component />}
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default SubStrucutureTerreni
